import { render, staticRenderFns } from "./Paas-Infra.vue?vue&type=template&id=e6c63772&scoped=true&"
import script from "./Paas-Infra.vue?vue&type=script&lang=js&"
export * from "./Paas-Infra.vue?vue&type=script&lang=js&"
import style0 from "./Paas-Infra.vue?vue&type=style&index=0&id=e6c63772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c63772",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
